import muster from '@dbk-legacy/muster';
import {Base64} from 'js-base64';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { PAYMENTS_PATH, PAYMENT_MODE } from './constant';
import Guid from '../../../utils/guid';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { pipeTemplate, toNumber } from './parser'
import { EBANKINGWEBLUX, EBANKINGWEBUK, MULTISIGN_TAB_SELECT,  RM_REGION, RM_REGION_CH,RM_REGION_UK, } from '../../../constants';
import { FETCH_MULTI_SIG_YES, FETCH_MULTI_SIG_NO } from './constant';
import envConfig  from '../../../../db-env-build';

export default () => muster()
  .path('payments.getPaymentHistory', {
    call: async ({ req }, { get, set, call }) => {
      const forceUpdate = req.args[0] === 'refetch'
      // const fetchMultisig = req.args[1] || 'N'tabSelectedForMultiUser
      const [tabSelected] = await getValues(get('payments.tabSelectedForMultiUser'));
      const fetchMultisig = tabSelected === 0 ? FETCH_MULTI_SIG_NO : FETCH_MULTI_SIG_YES
      const [list] = await getValues(get('payments.transactionList'))
      if (!forceUpdate && list.length) {
      //   // when dashboard page displayed again
      //   // do nothing, so there is no loading circle and no data updated.
      } else {
        set('payments.transactionListLoading', true);
        const channel = 'WEB';
        const deviceCode = ''
        const inputs = `${deviceCode}#@#${channel}#@#${fetchMultisig}`;
        const url = `${PAYMENTS_PATH}.listTransactions.["${inputs}"]["${Guid()}"]`
        const [result] = await getValues(get(url));
        try {
          const data = JSON.parse(result) 

          //handle api errors
          if (data.dwoMessage && data.dwoMessage.messages){
            set('payments.errorMsgs',data.dwoMessage.messages)
            set('payments.transactionListLoading', false);
          }       

          set('payments.signingType', data.signingType);
          set('payments.transactionListLoading', false);

          if(envConfig.envConfig === EBANKINGWEBLUX){
            const dataWithoutDomPay= data.resultList && data.resultList.filter((paymentItem) => (paymentItem.paymentType.paymentTypeName !== "DOMESTIC_PAYMENT" && paymentItem.paymentType.paymentTypeName !== "SWISS_QR_BILL_PAYMENT"));
            await set('payments.transactionList', dataWithoutDomPay || []); //nullish coalescing
          }else if(envConfig.envConfig === EBANKINGWEBUK){
            const dataWithoutSepaPay= data.resultList && data.resultList.filter((paymentItem) => (paymentItem.paymentType.paymentTypeName !== "SEPA_PAYMENT" && paymentItem.paymentType.paymentTypeName !== "SWISS_QR_BILL_PAYMENT"));
            await set('payments.transactionList', dataWithoutSepaPay || []); //nullish coalescing
          }else{
            await set('payments.transactionList', data.resultList || []); //nullish coalescing
          }
          //set multisign data 
            await set("payments.multiSignPaymentList", data.multisigResultList || []) //nullish coalescing
          if (data.multiSigNotificationDetails) {
            await set('payments.multiSigNotificationDetails', data.multiSigNotificationDetails || {})
            await call('notifications.pendingCountNotification', { notificationCategoryCountDtls: data.multiSigNotificationDetails.notificationCategoryCountDtls })// For updating multi-sig badge count
            await call('payments.updateNotificationBellCount')
          }          
        } catch (e) {
          set('payments.transactionList', []);
          set('payments.multiSignPaymentList', []); // fallback to empty array
          set('payments.isPaymentEndpointFailed', true);

        }
        set('payments.transactionListLoading', false);
      }
    },
  })

//To update value of notification bell total count after approval or rejection of multi-sig payment if Multi-sig approval setting is active
  .path('payments.updateNotificationBellCount', {
    call: async ({ req }, { get, set }) => {
      const [notifications] = await getValues(get('notifications.userNotifications'));
      const [multiSigNotificationDetails] = await getValues(get('payments.multiSigNotificationDetails'));
      const updated = {
        ...notifications,
      };
      let newCount = updated.total ? updated.total : 0
      const newObj = {
        ...updated,
        notifications: updated.notifications && updated.notifications.map(item => item.type === multiSigNotificationDetails.type ? multiSigNotificationDetails : item),
        totalDisplay: newCount + multiSigNotificationDetails.totalCount
      }
      if (updated.isMultiSig) {
        await set('notifications.userNotifications', newObj);
      }

    }
  })

  //  Payment Template starts here-------

  .path('payments.getTemplateList', {
    call: async ({ req }, { get, set }) => {
      const [messages] = await getValues(get('i18n.messages'));
      const guidStr = Guid();
      const [listData] = await getValues(get(`${PAYMENTS_PATH}.getTemplateList["${guidStr}"]`))
      isValidJsonString(listData).then(async data => {
        if (data && data.errorCode) {
          await Promise.all[(
            set('payments.errorMsg', data.message),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)
          )]
        } else {
          await Promise.all[(
            set('payments.templateList', data),
            set('payments.loading', false))]
        }
      })
        .catch(async error => {
          await Promise.all[(
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)
          )]
        })
    }
  })

  .path('payments.deleteTemplate', {
    call: async ({ req }, { get, set, call }) => {
      const templateId = req.args[0];
      await set('payments.loading', true);
      const [messages] = await getValues(get('i18n.messages'));
      const request = {
        templateId
      }
      const requestObj = Base64.encode(JSON.stringify(request));
      const guidStr = Guid();
      const inputParam = `${requestObj}`;
      const [oReturn] = await getValues(
        get(`${PAYMENTS_PATH}.deleteTemplate["${inputParam}"]["${guidStr}"]`)
      )
      isValidJsonString(oReturn)
        .then(async (data) => {
          if (data && data.templateId) {
            await call('payments.getTemplateList');
            await set('payments.deleteConfirmationModal', false);
            await set('payments.loading', false);
          } else if (data && data.errorCode) {
            await Promise.all([
              set('payments.errorMsg', data.message),
              set('payments.templateErrorModal', true),
              set('payments.loading', false)])
          }
        })
        .catch(async (error) => {
          await Promise.all([
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)])
        })
    }
  })

  .path('payments.initializePaymentCapture', {
    call: async ({ req }, { get, set, call }) => {

      await set('payments.isPaymentTemplateFlow', true); // required to change the title on Payment capture screen
      const [selectedTemp] = await getValues(get('payments.selectedPaymentTemplate'));

      // Populate Debit list
      const [debitList] = await getValues(get('payments.debtAcList'));
      const cashAccNo = selectedTemp.cashAccNo;
      const cashAccPfId = selectedTemp.cashAccPfId;
      const selectedAcnt = debitList && debitList.find(e => e.accNo === cashAccNo && e.pfId === cashAccPfId);
      await set('payments.paymentType', selectedTemp.paymentType && selectedTemp.paymentType.toLowerCase());
      await set('payments.selectedDebitAcnt', selectedAcnt);

      //Populate Beneficiary or Credit Account List
      if (selectedTemp.paymentType && selectedTemp.paymentType.toLowerCase().includes('internal')) {
        const toAccNo = selectedTemp.toCashAccNo;
        const toAccPfId = selectedTemp.toCashAccPfId;
        const selectedAcnt = debitList && debitList.find(e => e.accNo === toAccNo && e.pfId === toAccPfId);
        await set('payments.selectedCreditAcnt', selectedAcnt); // for internal payment type
      } else {
        const [beneficiaryList] = await getValues(get('payments.beneficiaryList'));
        const selectedBenf = beneficiaryList && beneficiaryList.find(e => e.beneficiaryId === selectedTemp.beneficiaryId);
        await call('payments.setBeneficiary', selectedBenf); // for all payment type except for  internal
      }

      // Populate Amout Fields
      const [currencyList] = await getValues(get('payments.curcyWhiteList'));
      const selectedCurrency = currencyList && currencyList.find(e => e.tech === selectedTemp.currencyTech && e.currencyKey === selectedTemp.currencyKey);
      await set('payments.selectedCurrency', selectedCurrency);
      await set('payments.amount', selectedTemp.amount);

      //Populate cost type
      const [selectedCostList] = await getValues(get('payments.costList'));
      const selectedCost = selectedCostList && selectedCostList.find(e => e.costTypeKey === parseInt(selectedTemp.costTypeKey));
      await set('payments.selectedCost', selectedCost);

      set('payments.remarks',selectedTemp.remarks && selectedTemp.remarks.replaceAll('\n', '') || '');
      set('payments.paymentReason', selectedTemp.payReasonKey || '');

    }
  })

  .path('payments.saveUpdateTemplate', {
    call: async ({ req }, { get, set, call }) => {
      await set('payments.loading', true);
      const [overrideTemp] = await getValues(get('payments.overrideTemp'));
      const [selectedPaymentTemplate, templateName,paymentType, selectedDebitAcnt, selectedCurrency, amount, selectedBeneficiaryBank, selectedCreditAcnt, selectedCost, payReasonKey, messages] = await getValues(
                          get(['payments.selectedPaymentTemplate','payments.templateName',
                          'payments.paymentType','payments.selectedDebitAcnt',
                          'payments.selectedCurrency','payments.amount','payments.selectedBeneficiaryBank','payments.selectedCreditAcnt','payments.selectedCost', 'payments.paymentReason', 'i18n.messages'])) 

      let [remarks] = await getValues(get(['payments.remarks']));
      // if(paymentReason && paymentReason != '') {
      //   remarks = `${paymentReason}-${remarks}`;
      // }
      const request = pipeTemplate({selectedPaymentTemplate, templateName,paymentType, selectedDebitAcnt, selectedCurrency, amount: toNumber(amount), selectedBeneficiaryBank, 
        selectedCreditAcnt, remarks, selectedCost, payReasonKey})
      
      if(overrideTemp){
         request.templateId = overrideTemp.templateId; // fix for WMCE-12691
      }
      const inputParam = Base64.encode(JSON.stringify(request));
      const guidStr = Guid();
      const [oReturn] = await getValues(
        get(`${PAYMENTS_PATH}.saveUpdateTemplate["${inputParam}"]["${guidStr}"]`)
      )
      isValidJsonString(oReturn)
        .then(async (data) => {
          if (data && data.templateId) {
            await set('payments.loading', false);
          } else if (data && data.errorCode) {
            await Promise.all([
              set('payments.errorMsg', data.message),
              set('payments.templateErrorModal', true),
              set('payments.loading', false)])
          }
        })
        .catch(async (error) => {
          await Promise.all([
            set('payments.errorMsg', messages['app.payments.failToConnect']),
            set('payments.templateErrorModal', true),
            set('payments.loading', false)])
        })
    }
  })

    // reset values of template item variables
    .path('payments.resetTemplateVariables', {
      call: async ({ req }, { get, set, call }) => {
        await Promise.all([
          set('payments.isPaymentTemplateFlow', false),
          set('payments.templateName', null),
          set('payments.isSaveEnabled', false),
          set('payments.selectedPaymentTemplate', null),
          set('payments.cancelTxFailMsg', null),
          set('payments.cancelTxFails', false),
          set('payments.isMultiSigApprovalFlow', false),
          set('payments.isMultiSigViewOnlyFlow', false)])          
    }})

  //  Payment Template ends here-------

  .path('payments.fetchPaymentList', {
    call: async ({ req }, { get, set, call }) => {

       const [tabSelectedForMultiUser] = await getValues(get('payments.tabSelectedForMultiUser'));

      const selectedTabIndex = req.args[0] || tabSelectedForMultiUser;

      const prevLang = localStorage.getItem('PrevSelectedLanguage');
      const currentLang = localStorage.getItem('SelectedLanguage');
      const newPayFlg = localStorage.getItem('newPaymentComplete');

      const refetch = (prevLang !== currentLang && prevLang !== null) || newPayFlg || envConfig.rmRegion === RM_REGION || envConfig.rmRegion === RM_REGION_CH || envConfig.rmRegion === RM_REGION_UK ? 'refetch' : '';

      const [isMultiSignFilterFlag] = await getValues(get('payments.multiSignFilterFlag'));
      const [isFilterFlag] = await getValues(get('payments.filterFlag'));
      const [multiSignFilterLookup] = await getValues(get('payments.multiSignFilterLookup'));
      const [paymentFilterLookup] = await getValues(get('payments.paymentFilterLookup'));

      if (selectedTabIndex === MULTISIGN_TAB_SELECT.MULTISIG_APPROVALS && isMultiSignFilterFlag) {
        await call('payments.applyMultiSignFilter', multiSignFilterLookup);
      }
      else if (selectedTabIndex === MULTISIGN_TAB_SELECT.SUBMITTED_PAYMENTS && isFilterFlag) {
        await call('payments.applyFilter', paymentFilterLookup);
      }
      else {
        await call('payments.getPaymentHistory', refetch);
      }

    }
  })

  .path('payments.transactionListLoading', variable(false))
  .path('payments.transactionList', variable([]))
  .path('payments.multiSignPaymentList', variable([]))
  .path('payments.multiSigNotificationDetails', variable({}))
  .path('payments.templateList', variable())
  .path('payments.selectedPaymentTemplate', variable())
  .path('payments.isPaymentTemplateFlow', variable(false))
  .path('payments.templateName', variable())
  .path('payments.saveModifiedTemplate', variable(false))
  .path('payments.isSaveEnabled', variable(false))
  .path('payments.templateErrorModal', variable(false))
  .path('payments.overrideTemp', variable(null))
  .path('payments.signingType', variable(PAYMENT_MODE.SINGLE))
  .path('payments.isPaymentEndpointFailed', variable(false))
  .path('payments.tabSelectedForMultiUser', variable(MULTISIGN_TAB_SELECT.SUBMITTED_PAYMENTS))


